import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function submitContact(data) {
  return (await api.post("/contact", data)).data;
}
export async function submitInstitution(data) {
  return (await api.post("/institution-inquiry", data)).data;
}
export async function submitStudent(data) {
  return (await api.post("/student-inquiry", data)).data;
}
export async function submitAdmission(data) {
  return (await api.post("/admission-application", data)).data;
}

const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export async function adminGetSubmissions(token) {
  return (await api.get("/admin/submissions", adminHeaders(token))).data;
}
export async function adminUpdateStatus(token, group, id, status) {
  return (await api.patch(`/admin/leads/${group}/${id}`, { status }, adminHeaders(token))).data;
}
export async function adminDeleteLead(token, group, id) {
  return (await api.delete(`/admin/leads/${group}/${id}`, adminHeaders(token))).data;
}
export async function subscribeNewsletter(email) {
  return (await api.post("/newsletter", { email })).data;
}
export async function fetchBlog() {
  return (await api.get("/blog")).data;
}
export async function fetchBlogPost(slug) {
  return (await api.get(`/blog/${slug}`)).data;
}
export async function fetchColleges(params = {}) {
  return (await api.get("/colleges", { params })).data;
}
